import { render } from "./BalanceSheetTree.vue?vue&type=template&id=1937bd54&scoped=true"
import script from "./BalanceSheetTree.vue?vue&type=script&lang=js"
export * from "./BalanceSheetTree.vue?vue&type=script&lang=js"

import "./BalanceSheetTree.vue?vue&type=style&index=0&id=1937bd54&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1937bd54"]])

export default __exports__